import { Observable, Subject } from 'rxjs';
import { Injectable, ComponentFactory } from '@angular/core';

export interface ComponentCreationParameters<T> {
  componentFactory: ComponentFactory<T>;
  onInit?(component: T): void;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
  private componentCreationParametersSubject: Subject<
    ComponentCreationParameters<any>
  > = new Subject();
  componentCreationParameters: Observable<
    ComponentCreationParameters<any>
  > = this.componentCreationParametersSubject.asObservable();

  /**
   * Instantiates the component in designated place using it's factory.
   * To get component factory, inject ComponentFactoryResolver
   * anywhere inside target's component module scope.
   * @method open
   * @param {T} type type of the component
   * @param {ComponentCreationParameters<T>} componentCreationParameters parameters to provide for component creation
   */
  open<T>(componentCreationParameters: ComponentCreationParameters<T>): void {
    this.componentCreationParametersSubject.next(componentCreationParameters);
  }

  close(): void {
    this.componentCreationParametersSubject.next(null);
  }
}
